import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandService } from 'src/app/api/catalog/brand.service';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
import * as moment from 'moment';
import { GroupService } from 'src/app/api/departure/group.service';
import { CookieService } from 'ngx-cookie-service';
declare var $: any;
import * as _ from 'underscore';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { SearchTourComponent } from 'src/app/components/search-tour/search-tour.component';
import { constants } from 'src/app/constants';
import { GroupGuideProjectionComponent } from '../group-guide-projection/group-guide-projection.component';

@Component({
  selector: 'app-group-list',
  templateUrl: './group-list.component.html',
  styleUrls: ['./group-list.component.css']
})
export class GroupListComponent implements OnInit {
  @ViewChild(SearchTourComponent) SearchTourComponent: any;
  @ViewChild(SearchComponent) searchComponent: any;
  @ViewChild(GroupGuideProjectionComponent) GroupGuideProjectionComponent: any;

  private thisComponent: GroupListComponent;
  branchofficeSlug = '';
  items: any = [];
  items_custom: any = [];
  params: any = {
    search: '',
    tour_id: null
  };
  page = 1;
  count = 0;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  // variables ========
  viewMode: 'grid' | 'list' = 'grid'; // Vista por defecto
  date_range: any = moment().format('YYYY-MM-DD');
  pin_date: any = false;
  tourSelected: any = null;
  vehicle_private: any = constants.TOURISM.VEHICLE_TOURS[1].id;

  constructor(
    private routeActivated: ActivatedRoute,
    private groupService: GroupService,
    private router: Router,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper,
    private cookies: CookieService,
    private elementRef: ElementRef,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;

    const cookieExists: boolean = this.cookies.check('pin_date_group');
    if (cookieExists) {
      let check_pin_date = JSON.parse(this.cookies.get('pin_date_group'));
      this.pin_date = check_pin_date;
      if (this.pin_date) {
        this.date_range = this.cookies.get('set_date_group');
      }
    }
  }

  ngOnInit() {
    // Recuperar la vista almacenada en cookies
    const savedView = this.cookies.get('viewMode');
    if (savedView === 'grid' || savedView === 'list') {
      this.viewMode = savedView;
    }
    
    let component_ = this.thisComponent;
    this.list();
    (<any>$('#date_range')).daterangepicker(
      {
        locale: {
          format: 'YYYY-MM-DD'
        },
        startDate: this.date_range,
        singleDatePicker: true,
        showDropdowns: true,
        autoApply: true
      },
      function(chosen_date: any) {
        (<any>$('#date_range')).val(chosen_date.format('YYYY-MM-DD'));
        component_.date_range = chosen_date.format('YYYY-MM-DD');
        component_.list();
      }
    );
    if (this.pin_date) {
      setTimeout(() => {
        (<any>$('#date_range')).attr('disabled', true);
      }, 50);
    }
    this.navigationTrackerService.initializeMenu(this.routeActivated);
  }

  list() {
    let val_params =
      'search=' +
      this.params.search +
      '&page=' +
      this.page +
      '&date_range=' +
      this.date_range +
      '&tour_id=' +
      this.params.tour_id;
    this.groupService.list(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.items_custom = Object.values(data.results_custom);
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
      }
    });
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.params.tour_id = null;
    this.searchComponent.textSearch = '';
    if (!this.pin_date) {
      this.date_range = moment().format('YYYY-MM-DD');
      (<any>$('#date_range')).val(this.date_range);
    }
    this.ngOnInit();
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/salidas/grupos/editar',
      id
    ]);
  }

  detail(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/salidas/grupos/detalle',
      id
    ]);
  }

  selectedTourSearch(item_: any) {
    this.tourSelected = item_;
    this.params.tour_id = this.tourSelected.id;
    this.list();
  }

  removeTour() {
    this.tourSelected = null;
    this.page = 1;
    this.params.search = '';
    this.params.tour_id = null;
    this.searchComponent.textSearch = '';
    this.list();
    setTimeout(() => {
      this.SearchTourComponent.focused();
    }, 150);   
  }

  changePinDate() {
    let value_pin: any = this.pin_date;
    let value_date_range: any = this.date_range;
    this.cookies.set('pin_date_group', value_pin);
    if (value_pin) {
      (<any>$('#date_range')).attr('disabled', true);
      this.cookies.set('set_date_group', value_date_range);
    } else {
      (<any>$('#date_range')).attr('disabled', false);
    }
  }

  setView(mode: 'grid' | 'list') {
    this.viewMode = mode;
    this.cookies.set('viewMode', mode);
  }
  
  printerPanel() {
    (<any>$('#generated-data')).printThis({
      importCSS: true
    });
  }

  delete(item: any, _index: any) {
    let options = {
      title: '¿Estás segur@?',
      message: ' de grupo N° ' + item.code,
      cancel: 'Cancelar',
      confirm: 'Eliminar'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.groupService.delete(item.id).subscribe({
          next: (data: any) => {
            this.items.splice(_index, 1);
            this.alertifyMsg.success(
              'El registro de grupo ' + item.code + ' se ha eliminado con éxito'
            );
            this.list();
          }
        });
      }
    });
  }

  scheduleProjection(){
    this.GroupGuideProjectionComponent.init();
  }
}
